export default "__VITE_ASSET__BW5xN85R__"